import React from 'react';

import { useAccount } from './useAccount';

export const usePollingUser = () => {
  const { refreshUser } = useAccount();
  const refreshIntervalRef = React.useRef<number | null>(null);

  const startPolling = () => {
    refreshUser();

    refreshIntervalRef.current = window.setInterval(() => {
      refreshUser();
    }, 2000);
  };

  React.useEffect(() => {
    const discardLongPollingTimeout = window.setTimeout(() => {
      if (refreshIntervalRef.current) {
        window.clearInterval(refreshIntervalRef.current);
      }
      // wait 2 minutes before discarding the long polling
    }, 120_000);

    return () => {
      if (refreshIntervalRef.current) {
        window.clearInterval(refreshIntervalRef.current);
      }
      if (discardLongPollingTimeout) {
        window.clearTimeout(discardLongPollingTimeout);
      }
    };
  }, []);

  const stopPolling = () => {
    if (refreshIntervalRef.current) {
      window.clearInterval(refreshIntervalRef.current);
    }
  };

  return { startPolling, stopPolling };
};
